import { render, staticRenderFns } from "./PolicyRiskDetails.vue?vue&type=template&id=079ce3aa&"
import script from "./PolicyRiskDetails.vue?vue&type=script&lang=js&"
export * from "./PolicyRiskDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports